import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
declare var $: any;
import swal from 'sweetalert2';

import { User } from '../shared/models/user';
import { environment } from '../../environments/environment';
import { StoreHelper } from '../shared/helpers/store.helper'
import { ControllerService } from '../shared/services/controller.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ReferencesService } from '../references.service';
@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    standalone: false
})
export class WelcomeComponent implements OnInit, OnDestroy, AfterViewInit {
  currentIndex: number = 1;
  maxIndex: number = 5;
  minIndex: number = 1;

  courseProgress: number = 0;
  duration: string = "";
  leader: string = environment.instanceType === 'education' ? "head teacher" : "judge";
  education: boolean = environment.instanceType === 'education';
  user: User;
  watchedIntro = null;
  loading: boolean = false
  whatsnext: boolean = false
  skipToEnd: boolean = false

  page = null

  baseUrl = environment.audioBaseDir

  qpListener = null

  pageNumber: number = 0

  pageComponents = []

  haveNextButton = false

  constructor( public controller: ControllerService, private activatedRoute: ActivatedRoute, private doms: DomSanitizer, private references:ReferencesService) {


    this.skipToEnd = StoreHelper.getObject('fastForward')

    this.loading = false
  }

  showReferences( ){


    const introVideoId = this.controller.getIntroVideoId()

    this.references.showReferences(introVideoId)
  }

  sanitizeUrl( url ){
    return this.doms.bypassSecurityTrustUrl(url)
  }

  ngOnInit() {


    $('body').removeClass();


    this.watchedIntro = this.controller.getSectionProperties().watchedIntro

    this.pageNumber = this.controller.getPage()

    this.whatsnext = this.controller.getSectionProperties().whatsnext

    this.qpListener = this.activatedRoute.queryParams.subscribe( (param) => {

      this.pageNumber = this.controller.getPage()
      this.pageComponents = this.controller.getSectionComponents().filter( ({type}) =>  type == 'page')
      this.watchedIntro = this.controller.getSectionProperties().watchedIntro
      this.page = this.pageComponents[this.pageNumber]

      this.haveNextButton = this.page.elements.find( ({type}) => type == 'next-button' )

    })

    this.pageComponents = this.controller.getSectionComponents().filter( ({type}) =>  type == 'page')


    if( ! this.pageComponents[0].elements.find( ({type}) => type === 'watch-now-button' ) ){
      this.watchedIntro = true
    }
  }

  ngOnDestroy() {
    $('body').removeClass('withOverflow');

    this.qpListener.unsubscribe()
  }

  ngAfterViewInit() {
  }


  async onNext() {
    const success = await this.controller.next()
  }

  gotoLibrary(){
    this.controller.goToLibrary()
  }

  async onWatchIntro() {

    // handle if we are watching again.

    if( this.watchedIntro ){
      this.controller.rewind(2)
    }
    await this.controller.next(false, this.watchedIntro )






  }

  onBack() {
    this.controller.back();
  }

  onGo() {


    this.controller.next()


  }

  onShowPopup(contentType = 0) {
    let content = `<h1>Measuring Unconscious Bias<br/>– a literature review</h1>
        <br/>
        <p>by Dr Lara Zibarras & Dr Kelly Winstanley</p>
        <br/>
        <br/>
        <br/>
        <p>The following report outlines a review of the literature on unconscious bias; in particular, how unconscious bias is currently measured, and what interventions exist that aim to reduce unconscious bias. After the introduction and methodology, our review has three main parts:</p>
        <br/><br/>
        <ol class="likeUL">
          <li>What methods exist currently for testing unconscious bias?</li>
          <li>Review of interventions that exist to reduce unconscious bias; how good are they?</li>
          <li>What are the lessons learnt?</li>
        </ol>
        <br/><br/>
        <p>A number of methods exist for testing unconscious bias. The predominant method is the Implicit Association Test (IAT) and alongside the standard IAT are its various derivatives (Brief IAT; Personalised IAT; Single Categories IAT). Although the IAT is the dominant method used within the research literature, it has also been subject to critique around its reliability and validity and our findings suggest it is difficult to draw clear conclusions on the utility of the IAT.</p>
        <br/><br/>
        <p>In addition to the IAT and its derivatives are other methods of testing for unconscious bias; including the Go No-Go association task; semantic priming and lexical decision task; evaluative priming task; should-would discrepancies scale; the affect misattribution procedure; and the bias awareness scale. The research literature for these other measures is much less extensive.</p>
        <br/><br/>
        <p>We uncovered a number of studies where the intention was to reduce bias. In this report, we categorised unconscious bias training interventions into six different techniques:</p>
        <br/><br/>
        <ol>
          <li>Discounting commonly held stereotypes;</li>
          <li>Using context to influence implicit responses;</li>
          <li>Changing the way an out-group member is evaluated and categorised;</li>
          <li>Using contact to change the level of threat evoked by an out group;</li>
          <li>Mindfulness Meditation; and</li>
          <li>Encouraging people to take responsibility for their implicit biases.</li>
        </ol>
        <br/><br/>
        <p>Whilst there were aspects of some of the methods that appeared to work in reducing implicit bias, again there is much critique levied at research around the extent to which it is actually bias that is being reduced, or whether the “reduction” is due to issues with the measure of bias itself. Nevertheless, a “good” intervention is likely to include multiple methods; be longitudinal in design; and actively involve participants throughout the process.</p>
        <br/><br/>
        <p>In conclusion, the areas of unconscious bias, its measurement and training interventions are ones that have garnered much attention both in the academic and practitioner literatures. Unconscious bias is seen as something that is important to deal with in organisations, yet at present there are many areas within the academic literature that lack clarity. First, there is no one technique to measure unconscious bias that is considered “good” by the majority of researchers; and second the research on interventions to reduce unconscious bias is patchy at best. One key issue is that the “interventions” have often been conducted in a way that hides the true nature of the task, which questions their relevance in an organisational setting.</p>
        <br/><br/>
        <p>The full report can be found <a class="dot-underline dark-link" target=_blank href="/assets/Measuring_Unconscious_Bias_Report.pdf">here</a>.</p>
        `;
    if (contentType == 1) {
      content = `
      <img src="/assets/img/report-01.jpg" srcset="/assets/img/report-01@2x.jpg 2x, /assets/img/report-01@3x.jpg 3x">
        <br/>
        <br/>
        <h1>Unconscious Bias In Graduate Recruitment</h1>
        <br/>
        <h4>Rare’s aim</h4>
        <p>There are many reports and initiatives on unconscious bias. We wanted a new approach that draws on our access to young, high achieving, under-represented, students in ways that can actively improve the recruitment process.</p>
        <br/>
        <h4>What we learned</h4>
        <p>The research on the unconscious is clear: we are all susceptible to a multitude of so-called unconscious biases; these biases are hardwired into our neural circuitry and exhibited in all of our everyday actions.</p>
        <br/>
        <p>Capital: a person’s economic, social and cultural capital is not only relevant to how they appear on paper but how they appear in person – especially, the extra-discursive dimensions of their presence – how often might we produce evaluative phrases such as: ‘she was very warm and personable’, for example?</p>
        <br/>
        <p>Cultural literacy: there exists a cultural, linguistic and social canon. This canon is, by its very nature, ‘the way things get done’. It is a metalanguage that enables social and business interaction. Not having access to, or experience of, this canon may place individuals at unfair, largely unconscious, disadvantages.</p>
        <br/>
        <p>Recruitment process: a blend of blind and contextualised stages will offer the most realistic and egalitarian recruitment process. We must control the information in the system: the best systems are both hyper-contextualised and blind.</p>
        <br/>
        <p>‘It’: we questioned what judgements are being made in an interview and how they might betray their conscious aim. When a particular candidate impresses us, when that candidate has ‘it’, what is ‘it’ and how might it informed by biases – feelings of warmth, comfort and familiarity, for example? These essays collectively attempt to describe ‘it’.</p>
        <br/>
        <h4>Outcomes / recommendations</h4>
        <p>There are two chapters that follow the series of essays: Rare recommends, and Rare’s Five Big Ideas for 2015. These chapters led directly to the development of Hemisphere.</p>
        <br/>
        <p>The full research report can be found <a class="dot-underline dark-link" target=_blank href="https://www.rarerecruitment.co.uk/static/research/2014_UB_in_graduate_recruitment.pdf">here</a>.</p>
        `;
    }
    swal({
      title: '',
      customClass: 'welcome-alert',
      html: content,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false
    });
  }
}
